<template>
  <div class="con">
    <div class="title">
      <h2>결제</h2>
      <p><br /></p>
    </div>
    <progress-bar></progress-bar>
    <div class="mt-50">
      <div class="apply-fieldset">
        <div class="apply-program-wrap">
          <div class="apply-select-number">
            선택한 클래스 <span v-if="sessionData.classList" class="txt-red">({{ subjectLength }})</span>
            <button class="pointer" @click="moveSelectPage()">다시 선택하기</button>
          </div>
          <div class="apply-program-select">
            <ul>
              <div v-for="(classItem, idx) of sessionData.classList" :key="idx">
                <!-- 선택 했을 경우 -->
                <li class="program-select blue" v-for="(item, index) of classItem.subjectList" :key="index">
                  <div class="apply-program-unit">
                    <ul>
                      <!-- 선택한 컬러로 클래스 노출, class="blue" -->
                      <li class="unit-title blue" data-toggle="modal" data-target="#program-info">
                        <h4 class="pay-title" @click="openModal(item)">{{ item.subjectName }}</h4>
                        <img src="../../assets/img/close.png" class="pointer" alt="" @click="deleteClass(index)" />
                      </li>
                      <li>
                        <p v-for="(item, index) of viewItemList(item)" :key="index">
                          <span
                            >{{ item.key || "-" }} <b class="bold">{{ item.value || "-" }}</b></span
                          >
                        </p>
                      </li>
                    </ul>
                  </div>
                </li>
              </div>
            </ul>
          </div>
        </div>
        <div class="hq-table-row">
          <h3>신청자 정보</h3>
          <table>
            <colgroup>
              <col width="30%" />
              <col width="70%" />
            </colgroup>
            <tbody>
              <tr v-for="(item, index) of info" :key="index">
                <th>{{ item.item_name }}</th>
                <td>{{ item.value }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="hq-table-row">
          <h3>결제 정보</h3>
          <table>
            <colgroup>
              <col width="30%" />
              <col width="70%" />
            </colgroup>
            <tbody>
              <tr>
                <th>결제금액</th>
                <td>{{ totalPayment }}원</td>
              </tr>
              <tr>
                <th>결제방법</th>
                <td>
                  <label for="card" v-show="payWay.pay_way === 'C'">
                    <input type="radio" v-model="payType" name="payTypeC" id="" value="card" />
                    <span class="txt-13px ml-05 mr-20">카드결제</span>
                  </label>
                  <label for="pay" v-show="payWay.pay_way === 'A'">
                    <input type="radio" v-model="payType" name="payTypeA" id="" value="trans" />
                    <span class="txt-13px ml-05 mr-20">실시간 계좌이체</span>
                  </label>
                  <label for="pay" v-show="payWay.pay_way === 'D'">
                    <input type="radio" v-model="payType" name="payTypeD" id="" value="card" />
                    <span class="txt-13px ml-05 mr-20">카드결제</span>
                    <input type="radio" v-model="payType" name="payTypeD" id="" value="trans" />
                    <span class="txt-13px ml-05 mr-20">실시간 계좌이체</span>
                  </label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="apply-agree-btn">
      <button type="button" :class="setButtonColor()" @click="apply()">{{ isFinishPage ? "수강신청 하기" : "다음" }}</button>
    </div>
    <detail-process v-if="isDetailModalOpened" :parentData="parentData" @close="closeModal()"></detail-process>
  </div>
</template>

<script>
import Vue from "vue";
import DetailProcess from "@/components/reg/select/detailModal.vue";

const EventBus = new Vue();
const IMPCODE_APPLY = "imp28895051"; // Carrotglobal Iamport 실제 IMP코드

const PGCODE_F = "kicc.IM000066"; // 글로벌 면세
const PGCODE_T = "kicc.IM000065"; // 글로벌 과세

const solutions_PGCODE_F = "kicc.IM000106"; // 솔루션 면세
const solutions_PGCODE_T = "kicc.IM000105"; // 솔루션 과세

const PGCODE_F_TEST = "kicc.T5102001"; // 글로벌 면세
const PGCODE_T_TEST = "kicc.T5102001"; // 글로벌 과세

const solutions_PGCODE_F_TEST = "kicc.T5102001"; // 솔루션 면세
const solutions_PGCODE_T_TEST = "kicc.T5102001"; // 솔루션 과세

export default {
  components: {
    DetailProcess,
  },
  data: () => ({
    sessionData: {}, // 세션 스토리지 수강신청 등록 전체 데이터
    info: [], // 전 페이지에서 사용자 정보 입력된 데이터
    payWay: {}, // 지불 방법
    totalPayment: 0, // 결제 최종 금액
    payType: "card", // card: 카드결제, trans: 실시간 계좌이체

    merchantUid: "", // api 결제 승인났을때 고유 아이디 받음 (이 아이디로 iamport에 사용)
    orderId: "", // 주문 id
    impUid: "", // imp id
    isDetailModalOpened: false, // 클래스 상세보기 레이어팝업 on/off
    parentData: {}, // 레이어팝업에 전달할 해당 강의 데이터
    mainIdx: "",

    payWayP: "C", // 지불 방법
    partialPay: "A", // 전체결제 A 부분결제 P
    taxType: "T", // 과세 T, 면세 F
    pgCodeType: "inicis",
    isFinishPage: false, // 현재 페이지가 마지막 페이지인지
    subjectLength: 0,
    pageIdx: "",

    pointColor: "blue",
  }),


  watch: {
    // 등록 페이지 내의 현재 라우터 경로 감지
    // Watch에 넣어놓은 이유는 keep-alive 사용으로 페이지 진입후 재진입할때 mount가 안되기 때문
    $route(to) {
      if (this.$route.fullPath === "/user/reg/payment") {
        this.loadSugangData();
      }
    },
  },

  mounted() {
    this.pointColor = sessionStorage.getItem("pointColor");

    this.loadSugangData();
    //TODO: idx 추후에 변경해야함
    var idx = sessionStorage.getItem("mainIdx");
    this.mainIdx = sessionStorage.getItem("mainIdx");
    var params = {
      idx: idx,
    };
    this.axios.get(this.axios.root + this.axios.port + `/sugang/pay-way/${idx}`).then((res) => {
      // console.log('res', res)
      if (res.data.err === 0) {
        this.payWay = res.data.payWay;
        this.taxType = res.data.payWay.tax_type;

        if (this.payWay.pay_way === "C") {
          this.payType = "card";
          this.payWayP = "C";
        } else if (this.payWay.pay_way === "A") {
          this.payType = "trans";
          this.payWayP = "A";
        }

        if (res.data.payWay.partial_pay) {
          this.partialPay = res.data.payWay.partial_pay;
        }
      } else {
        alert(res.data.result);
      }
    });


    var pathArray = this.$route.fullPath.split("/");
    var length = pathArray.length;
    var pageType = pathArray[length - 1];
    var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
    var finishPage = pOrder[pOrder.length - 1];

    if (pageType === finishPage) {
      this.isFinishPage = true;
    }
  },

  methods: {
    setButtonColor() {
      if (this.pointColor === "Blue") {
        return "blue";
      } else if (this.pointColor === "Red") {
        return "red";
      } else if (this.pointColor === "Green") {
        return "green";
      }
    },

    // 선택한 클래스 삭제
    deleteClass(idx) {
      this.totalPayment -= this.sessionData.classList[0].subjectList[idx].eduPrice + this.sessionData.classList[0].subjectList[idx].bookPrice;
      this.sessionData.classList[0].subjectList.splice(idx, 1);
    },

    // 클래스선택 페이지로 이동
    moveSelectPage() {
      this.$router.push("/user/reg/select");
    },

    // 세션 스토리지 수강신청 전체 데이터 loading
    loadSugangData() {
      this.sessionData = JSON.parse(sessionStorage.getItem("classData"));
      this.pageIdx = sessionStorage.getItem("pageIdx");
      // console.log('sessionData', this.sessionData)
      this.info = this.sessionData.info;
      this.totalPayment = this.sessionData.totalPayment;

      var count = 0;
      if (this.sessionData.classList) {
        for (var item of this.sessionData.classList) {
          for (var subject of item.subjectList) {
            count += 1;
          }
        }
      }

      this.subjectLength = count;

      for (var item of this.info) {
        if (item.item_name === "이름") {
          this.name = item.value;
          // console.log('item.value', item.value)
        } else if (item.item_name.includes("E-mail@")) {
          // console.log('item.value', item.value)
          this.email = item.value;
        }
      }
    },

    // 숫자 1000 단위로 콤마찍기 (1000 => 1,000)
    numberFormat(inputNumber) {
      // console.log(inputNumber, inputNumber)
      if (inputNumber) {
        return inputNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return "-";
      }
    },

    storeMobilePayData() {
      //var infoData = JSON.parse(JSON.stringify(this.sessionData['info']))
      console.log(this.sessionData);
      if (this.sessionData) {
        console.log("before sessiondata");
        var mobilePayData = JSON.parse(JSON.stringify(this.sessionData));
        console.log("after sessiondata : ", mobilePayData);

        mobilePayData["idxItmSugangPageMain"] = sessionStorage.getItem("pageIdx");
        mobilePayData["partialPay"] = this.partialPay;
        mobilePayData["payStatus"] = "Y";
        if (mobilePayData["mobile"]) {
          mobilePayData["mobile"] = mobilePayData["mobile"];
        } else {
          mobilePayData["mobile"] = "";
        }
        mobilePayData["payWay"] = this.payWayP;
        mobilePayData["type"] = "Y";
        mobilePayData["programIdx"] = sessionStorage.getItem("programIdx");

        mobilePayData["studentSubjectIdx"] = -1;

        var itemNames = ["이름", "비밀번호", "사번", "휴대전화번호", "직급", "부서", "회사", "공인시험점수"];
        var count = 1;

        if (mobilePayData["info"]) {
          for (var item of mobilePayData["info"]) {
            if (item.item_name.includes("E-mail@")) {
              continue;
            } else if (itemNames.includes(item.item_name)) {
              continue;
            } else {
              mobilePayData["optionName" + count.toString()] = item.item_name;
              mobilePayData["optionContents" + count.toString()] = item.value;
              count += 1;
            }
          }
        }

        //delete mobilePayData['info']
        delete mobilePayData["totalPayment"];

        localStorage.setItem("mobilePayData", JSON.stringify(mobilePayData));
      }
    },
    saveChkTmp(orderId,impUid,merchantUid,amount,url) {
      var infoData = JSON.parse(JSON.stringify(this.sessionData["info"]));

      this.sessionData = {
        ...this.sessionData,
        info: infoData,
        idxItmSugangPageMain: sessionStorage.getItem("pageIdx"),
        partialPay: this.partialPay,
        payStatus: 'Y',
        mobile : this.sessionData.mobile ? this.sessionData.mobile:'' ,
        payWay : this.payWayP,
        amount: amount,
        merchantUid: merchantUid,
        impUid: impUid,
        orderId : orderId,
        type : 'Y',
        programIdx: sessionStorage.getItem('programIdx'),
        studentSubjectIdx: -1,
      }

      var itemNames = ["이름", "비밀번호", "사번", "휴대전화번호", "직급", "부서", "회사", "공인시험점수"];
      var count = 1;

      if (this.sessionData["info"]) {
        for (var item of this.sessionData["info"]) {
          if (item.item_name.includes("E-mail@")) {
            continue;
          } else if (itemNames.includes(item.item_name)) {
            continue;
          } else {
            this.sessionData["optionName" + count.toString()] = item.item_name;
            this.sessionData["optionContents" + count.toString()] = item.value;
            count += 1;
          }
        }

      }

      let params = this.sessionData;

      console.log(params)
      this.axios
        .post(this.axios.root + this.axios.port + url, params)
        .then(async (res) => {
          if (Number(res.data.err) === 0) {
          } else {
            return false;
          }
        })
        .catch(async (err) => {
          console.error(url+"error : ", err);
          alert("데이터 저장에 실패했습니다.");
        });
    },

    // 수강신청 전체 데이터 저장
    save(orderId,impUid,merchantUid,amount) {
      // let params = new URLSearchParams()
      // params.append('orderId', orderId)
      // params.append('impUid', impUid)
      console.log(this.sessionData);
      console.log(this.sessionData["info"]);
      console.log(this.sessionData.info);
      var infoData = JSON.parse(JSON.stringify(this.sessionData["info"]));

      // delete this.sessionData['info']
      // delete this.sessionData['totalPayment']

      this.sessionData["idxItmSugangPageMain"] = sessionStorage.getItem("pageIdx");
      // this.sessionData['number'] = '5'
      this.sessionData["partialPay"] = this.partialPay;
      this.sessionData["payStatus"] = "Y";
      // this.sessionData['position'] = 'manager'
      // this.sessionData['mobile'] = '010-9759-3585'
      if (this.sessionData["mobile"]) {
        this.sessionData["mobile"] = this.sessionData["mobile"];
      } else {
        this.sessionData["mobile"] = "";
      }
      this.sessionData["payWay"] = this.payWayP;
      this.sessionData["amount"] = amount
      this.sessionData["merchantUid"] = merchantUid;
      this.sessionData["impUid"] = impUid;
      this.sessionData["orderId"] = orderId;
      this.sessionData["type"] = "Y";
      this.sessionData["programIdx"] = sessionStorage.getItem("programIdx");

      this.sessionData["studentSubjectIdx"] = -1;

      var itemNames = ["이름", "비밀번호", "사번", "휴대전화번호", "직급", "부서", "회사", "공인시험점수"];
      var count = 1;

      if (this.sessionData["info"]) {
        for (var item of this.sessionData["info"]) {
          if (item.item_name.includes("E-mail@")) {
            continue;
          } else if (itemNames.includes(item.item_name)) {
            continue;
          } else {
            this.sessionData["optionName" + count.toString()] = item.item_name;
            this.sessionData["optionContents" + count.toString()] = item.value;
            count += 1;
          }
        }

        delete this.sessionData["info"];
      }

      delete this.sessionData["totalPayment"];
      // this.sessionData['userIdx'] = 1
      // 테스트데이터
      // this.sessionData['optionContents1'] = '5'
      // this.sessionData['optionContents2'] = '5'
      // this.sessionData['optionContents3'] = '5'
      // this.sessionData['optionContents4'] = '5'
      // this.sessionData['optionContents5'] = '5'
      // this.sessionData['optionName1'] = '5'
      // this.sessionData['optionName2'] = '5'
      // this.sessionData['optionName3'] = '5'
      // this.sessionData['optionName4'] = '5'
      // this.sessionData['optionName5'] = '5'

      let params = this.sessionData;

      this.axios
        .post(this.axios.root + this.axios.port + "/user/check-subjectdup", params)
        .then(async (res) => {
          if (Number(res.data.err) === 0) {
            this.applyregister(params);
            //this.$router.push('/user/applyList');
          } else {
            alert(res.data.result);
            //결제취소
            await this.cancelPay();
            return false;
          }
        })
        .catch(async (err) => {
          console.error("/user/check-subjectdup error : ", err);
          alert("중복확인하는 과정에서 서버오류로 인하여 결제에 실패하였습니다.");
          await this.cancelPay();
        });
    },

    // 수강신청 등록
    applyregister(params) {
      this.axios
        .post(this.axios.root + this.axios.port + "/pay/confirmToApply", params)
        .then((res) => {
          // console.log('최종 저장 res', res)
          if (typeof window.socket !== "undefined") {
            let isCon = window.socket.connected;
            if (isCon == true) {
              // alert("dis")
              // this.$socket.emit("disconnecting")
              window.socket.disconnect();
            }
          }

          if (res.data.err === 0) {
            if (res.data.subjectList) {
              sessionStorage.setItem("finishData", JSON.stringify(res.data.subjectList));
            }
            localStorage.setItem("accessToken", res.data.accessToken);
            this.axios.defaults.headers.common["accessToken"] = res.data.accessToken;
            if (this.isFinishPage) {
              alert("수강신청이 완료되었습니다.");
              this.$router.push("/user/applyList");
            } else {
              if (res.data.resultType !== undefined && res.data.resultType !== null) {
                alert(res.data.resultType);
              }
              var pOrder = JSON.parse(sessionStorage.getItem("pOrder"));
              var idx = pOrder.indexOf("payment") + 1;
              sessionStorage.setItem("step", pOrder[idx]);
              sessionStorage.setItem("classData", JSON.stringify(this.sessionData));
              this.$router.push(`/user/reg/${pOrder[idx]}`);
            }
          } else {
            alert(res.data.result);
            return false;
          }
        })
        .catch(async (err) => {
          console.error("/user/apply error : ", err);
          alert("수강신청 등록하는 과정에서 서버오류로 인하여 결제에 실패하였습니다.");
          await this.cancelPay();
        });
    },

    viewItemList(data) {
      if (data.columnOrder) {
        var itemList = data.columnOrder.split("^");
        var returnItemList = [];
        for (var item of itemList) {
          if (item === "언어") {
            returnItemList.push({
              key: item,
              value: data.language,
            });
          } else if (item === "장소") {
            returnItemList.push({
              key: item,
              value: data.place,
            });
          } else if (item === "요일") {
            if (data.day && typeof data.day === "string") {
              returnItemList.push({
                key: item,
                value: data.day.replace(/\^/gi, ""),
              });
            }
          } else if (item === "교육시간") {
            returnItemList.push({
              key: item,
              value: data.subjectStartTime + "~" + data.subjectEndTime,
            });
          } else if (item === "교육비") {
            returnItemList.push({
              key: item,
              value: data.eduPrice,
            });
          } else if (item === "교재비") {
            returnItemList.push({
              key: item,
              value: data.bookPrice,
            });
          }
        }

        return returnItemList;
      } else {
        return [];
      }
      // console.log('data', data)
      return [""];
    },

    // 수강신청 하기
    apply() {
      var self = this;
      if (self.sessionData.classList[0].subjectList.length === 0) {
        alert("선택한 클래스가 1개 이상 있어야 합니다.");
        return false;
      }

      if (self.payType === "card") {
        self.payWayP = "C";
      } else if (self.payType === "trans") {
        self.payWayP = "A";
      }
      // if (Number(sessionStorage.getItem('step')) < 5) {
      //     sessionStorage.setItem('step', 5)
      // }

      // let formData = new FormData()

      // formData.append('bookPriceYN', 'Y')
      // formData.append('payWay', 'C')
      // formData.append('partialPay', 'A')
      // formData.append('status', 'N')
      // formData.append('price', 100)
      // formData.append('subjectName', '테스트과목')
      // formData.append('totalPrice', 200)

      // self.axios.post(self.axios.root + self.axios.port + '/pay/check', formData)
      //     .then(res => {
      // console.log('res', res)
      //     })

      var params = [];
      for (var item of self.sessionData.classList) {
        for (var subject of item.subjectList) {
          var tempQuery = {
            bookPriceYN: "Y",
            idxItmSugangPageMain: self.pageIdx,
            // idxItmSugangStudent: 1,
            idxItmSugangSubject: subject.subjectIdx,
            name: self.name,
            email: self.email,
            payWay: self.payWayP,
            partialPay: self.partialPay,
            status: "N",
            price: subject.eduPrice + subject.bookPrice,
            subjectName: subject.subjectName,
            totalPrice: self.totalPayment,
          };

          // if (subject.eduPrice === 0 || subject.bookPrice === 0) {
          //     tempQuery['partialPay'] = 'P'
          // } else {
          //     tempQuery['partialPay'] = 'A'
          // }

          if (subject.eduPrice === 0 && subject.bookPrice !== 0) {
            tempQuery["partialPay"] = "B";
          } else if (subject.eduPrice !== 0 && subject.bookPrice === 0) {
            tempQuery["partialPay"] = "C";
          } else {
            tempQuery["partialPay"] = "A";
          }
          params.push(tempQuery);
        }
      }

      if (self.totalPayment === 0 || self.totalPayment === "") {
      }
      // console.log(params)
      if (params[0].name == "") {
        alert("사용자 정보를 다시 한번 확인해 주세요.");
        return false;
      }
      if (params[0].email == "") {
        alert("사용자 정보를 다시 한번 확인해 주세요.");
        return false;
      }
      // console.log(params[0].name);
      if (params[0].name == null) {
        alert("사용자 정보를 다시 한번 확인해 주세요.");
        return false;
      }
      if (params[0].email == null) {
        alert("사용자 정보를 다시 한번 확인해 주세요.");
        return false;
      }
      if (typeof params[0].name == "undefined") {
        alert("사용자 정보를 다시 한번 확인해 주세요.");
        return false;
      }
      if (typeof params[0].name == "undefined") {
        alert("사용자 정보를 다시 한번 확인해 주세요.");
        return false;
      }
      // 모바일 데이터 localstorage에 저장
      self.storeMobilePayData();
      self.axios
        .post(self.axios.root + self.axios.port + "/pay/check", params)
        .then((res) => {
          // console.log('res', res)
          if (res.data.err === 0) {
            self.merchantUid = res.data.merchantUid;

            var IMP = window.IMP; // 생략가능

            var impCode;
            // if (self.axios.type === 'apply') {
            //     impCode = IMPCODE_APPLY
            // } else {
            //     impCode = IMPCODE_TEST
            // }

            impCode = IMPCODE_APPLY;
            // console.log(window.location.host);
            // console.log(self.axios.type);
            // console.log(impCode);
            IMP.init(impCode);
            var noticeUrl = null;

            if (window.location.host === "apply.carrotglobal.com" || window.location.host === "apply2.carrotglobal.com") {
              noticeUrl = 'https://apply-api.carrotglobal.com/external/sugang/new/webhook'
              console.log("master")
              if (self.taxType === "F") {
                self.pgCodeType = PGCODE_F;
              } else {
                self.pgCodeType = PGCODE_T;
              }
            } else {
              noticeUrl = 'https://stage-itmsugang-api.carrotenglish.net/external/sugang/new/webhook'
              console.log("stage")
              if (self.taxType === "F") {
                self.pgCodeType = PGCODE_F_TEST;
              } else {
                self.pgCodeType = PGCODE_T_TEST;
              }
            }
            self.saveChkTmp(res.data.merchantUid, "", res.data.merchantUid,self.totalPayment, "/pay/checkTmp");
            IMP.request_pay(
              {
                pg: self.pgCodeType,
                // pg: 'kicc.T5102001',
                // pg: 'inicis', // version 1.1.0부터 지원.
                // pg: 'kicc.IM000066', // 글로벌 면세
                // pg: 'kicc.IM000065', // 글로벌 과세
                pay_method: self.payType,
                merchant_uid: self.merchantUid,
                // merchant_uid: '123',
                name: "주문명:" + self.sessionData.classList[0].className,
                amount: self.totalPayment,
                buyer_email: self.email,
                buyer_name: self.name,
                buyer_tel: "",
                notice_url : noticeUrl,
                // pg: 'inicis', // version 1.1.0부터 지원.
                // pay_method: 'card',
                // // merchant_uid: 'merchant_' + new Date().getTime(),
                // merchant_uid: res.data.merchantUid,
                // name: '주문명:' + self.productName,
                // amount: self.quantity * self.price,
                // buyer_email: self.userEmail,
                // buyer_name: self.userName,
                // buyer_tel: self.userPhone,

                // buyer_addr: '서울특별시 광진구 중곡4동 영화사로9길 24',
                // buyer_postcode: '123-456',
                // TODO: 상용 배포시 바꿔야함

                m_redirect_url: self.axios.defaultUrl + "/paymentRedirect",
                // m_redirect_url: 'http://localhost:8081/paymentRedirect'
                // m_redirect_url: 'http://apply.carrotglobal.com/user/reg/complete'
                // m_redirect_url: self.axios.root + '/purchaseComplete'
                // m_redirect_url: 'https://www.yourdomain.com/payments/complete'
              },
              function (rsp) {
                if (rsp.success) {
                  var msg = "결제가 완료되었습니다.";
                  msg += "고유ID : " + rsp.imp_uid;
                  msg += "상점 거래ID : " + rsp.merchant_uid;
                  msg += "결제 금액 : " + rsp.paid_amount;
                  msg += "카드 승인번호 : " + rsp.apply_num;

                  self.orderId = rsp.merchant_uid;
                  self.impUid = rsp.imp_uid;
                  self.save(rsp.merchant_uid, rsp.imp_uid, rsp.merchant_uid,rsp.paid_amount);

                } else {
                  msg = "결제에 실패하였습니다.";
                  msg += "에러내용 : " + rsp.error_msg;
                  alert(msg);
                }
              }
            );
          } else {
            alert(res.data.result);
          }
        })
        .catch((err) => {
          // console.log('err', err)
          alert(err);
        });

      // self.$router.push('/user/reg/complete')
    },

    // 클래스 상세보기 레이어팝업 열기
    openModal(data) {
      this.parentData = data;
      this.isDetailModalOpened = true;
    },

    // 모달 닫기
    closeModal() {
      this.isDetailModalOpened = false;
    },

    /**
     * @desription : 결제 취소
     */
    async cancelPay() {
      //가격 , 주문id
      await this.axios
        .post(this.axios.root + this.axios.port + "/pay/cancel?" + `amount=${this.totalPayment}&merchantUid=${this.merchantUid}`, {})
        .then((res) => {
          if (!res.data.err === 0) {
            alert("결제 취소에 실패하였습니다.");
          }
        })
        .catch((err) => {
          console.error(`cancelPay error : `, err);
          alert("서버에러로 인하여 결제가 실패하였습니다.");
        });
    },
  },
};
</script>
